import { InjectionToken } from '@angular/core';

export const BLEAGLE_APP_CONFIG = new InjectionToken<any>('Default configuration for the app');
